import { useEffect, useState } from "react";
import { Modal, Button, Typography, Spin, notification, List } from "antd";
import { FiPower } from "react-icons/fi";
import { BsLink45Deg } from "react-icons/bs";
import { Link, useNavigate } from "react-router-dom";
import { alertFormatter } from "../../../helperFuncs";
import { useGetMeterDetailsMutation } from "../../../services/meter.services";
import { useMQTT } from "../../../context/MqttContext";

const { Text, Title } = Typography;

const AlertModal = ({ responsedata, setresponsedata, open, setopen }) => {
  const { mqttEvents } = useMQTT();
  const [name, setName] = useState("");
  const navigate = useNavigate();

  const [getMeterDetails, { isLoading, data }] = useGetMeterDetailsMutation();

  useEffect(() => {
    if (!responsedata?.deviceid) return;
    getMeterDetails(responsedata?.deviceid).then((res) => {
      if (res.error) {
        notification.error({
          message: "Failed",
          description: "failed to get meter info",
        });
        return;
      }
    });
  }, []);

  const handleClose = () => {
    setresponsedata("");
    setopen();
  };

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      footer={null}
      centered
      width={400}
    >
      <Title level={4} className="text-center">
        {responsedata?.alerttype
          ? alertFormatter(responsedata?.alerttype).title
          : responsedata?.type
          ? alertFormatter(responsedata?.type).title
          : ""}
      </Title>

      <Text className="block text-center text-gray-700">
        {responsedata ? alertFormatter(responsedata?.alerttype).caption : ""}
      </Text>

      {/* <div className="flex items-center justify-center mt-4">
        <div className="w-12 h-12 flex items-center justify-center rounded-full border-2 border-green-500 bg-white shadow-md">
          <FiPower color="green" size={23} />
        </div>
      </div> */}

      <div className="mt-4 text-center">
        <p type="primary text-start">Meter Details:</p>

        <div className="font-semibold text-gray-800">
          {isLoading ? <Spin /> : name}
        </div>

        <List
          bordered
          size="small"
          dataSource={[
            { title: "Meter ID", value: data?.meterid },
            // { title: "Type", value: data?.type },
            { title: "Number of Phases", value: data?.phases },
            // { title: "Registrar", value: data?.registrar },
            { title: "Assigned To", value: data?.assignedto },
            { title: "RF Meter", value: data?.rfmeter ? "Yes" : "No" },
            { title: "Load Limit", value: `${data?.loadlimit} kW` },
            // { title: "Date Registered", value: data?.dateregistered },
          ]}
          renderItem={(item) => (
            <List.Item className="">
              <div className="flex items-center justify-between">
                <Text className=" block" strong>
                  {item.title}:
                </Text>
              </div>
              {item.title === "Meter ID" || item.title === "Assigned To" ? (
                <p
                  className="underline text-blue-600"
                  role="button"
                  onClick={() => {
                    handleClose();
                    navigate(
                      `/meter-details/${data?.assignedto}/${data?.meterid}`
                    );
                  }}
                >
                  {item.value}
                </p>
              ) : (
                <Text className=" block">{item.value}</Text>
              )}
            </List.Item>
          )}
        />
        {/* <div
          className="mt-3 cursor-pointer text-blue-500 underline flex items-center justify-center gap-1"
          onClick={() => {
            handleClose();
            //  / zannu003 / 3550000000201;
            navigate(`/meter-details/${data?.assignedto}/${data?.meterid}`);
          }}
        >
          Go to channel <BsLink45Deg size={18} />
        </div> */}
      </div>
    </Modal>
  );
};

export default AlertModal;
